import { isWardRoute } from 'domains/viewer/Viewer/Ward/utils';
import { useViewerMatch } from 'utils/viewerUrlUtils';

export const useViewerId = (): Nullable<string> => {
  const match = useViewerMatch();

  // Special handling for WARD: we'll assume windowId '0' if on the special route
  const isWard = isWardRoute();

  return match?.params?.windowId ?? (isWard ? '0' : null);
};
